import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/elements/button';
import { CircleCheck, Security } from '../../assets/icons';

const VerificationSuccess = () => {
    const navigate = useNavigate();

    return (
        <div className="auth-container">
            <div className="verification-success">
            <div className="auth-logo-section">
                                E-AQUAHEALTH
                                <img src={Security} alt="security"/>
                            </div>
                <img src={CircleCheck} alt="Success" className="success-icon" />
                <h1>Email Verified Successfully!</h1>
                <p>Your email has been verified. You can now access all features of E-AquaHealth.</p>
                <Button 
                    text="Continue to Login" 
                    onClick={() => navigate('/login')}
                    fullWidth
                />
            </div>
        </div>
    );
};

export default VerificationSuccess;